import { getMetaFromJcamp, getTargetProperty, referenceFind, } from "../common.js";
const hgPorosimetry = {
    jpath: ['spectra', 'hgPorosimetry'],
    find: referenceFind,
    getProperty: getTargetProperty,
    process: getMetaFromJcamp,
};
export default hgPorosimetry;
//# sourceMappingURL=hgPorosimetry.js.map